const PracticeAreaTagsStyle = {
  container: 'flex gap-1 items-center flex-nowrap',
  tag: 'bg-gray-100 text-gray-700 rounded py-0.5 px-2 text-xs whitespace-nowrap',
  overflow: 'bg-gray-100 text-gray-500 rounded py-0.5 px-2 text-xs whitespace-nowrap',
  empty: 'text-gray-400',
};

export default PracticeAreaTagsStyle;
